import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';

import Spinner from '@/components/shared/spinner';
import TopNav from '@/components/top-nav';

export type LayoutContextType = {
  setIsTopNavVisible: (visible: boolean) => void;
};

const MainLayout = () => {
  const [isTopNavVisible, setIsTopNavVisible] = useState(true);

  return (
    <div className="min-h-screen min-w-screen bg-primary">
      <Suspense fallback={<Spinner />}>
        {isTopNavVisible && <TopNav />}
        <main>
          <Outlet context={{ setIsTopNavVisible } satisfies LayoutContextType} />
        </main>
      </Suspense>
    </div>
  );
};

export default MainLayout;
